import { CRolesID } from "@/shared/models/const/roles.const";
import { TRolesId } from "@/shared/models/enums/roles/roles-id.enum";
import { IAgencyBaseEntity } from "@/shared/models/interfaces/entity/agency/agency-base.interface";
import { IUserLoggedEntity } from "@/shared/models/interfaces/entity/user-logged/user-logged.entity";
import { ILoginResponseData } from "@/shared/models/interfaces/response/auth/login-response.interface";

import { I_CurrentUserResponseData } from "../model/responses/current-user";

// adapter for user logged

type UserAuthenticateAdapter = (
  data: ILoginResponseData
) => IUserLoggedEntity;

type values = ILoginResponseData | I_CurrentUserResponseData;

const UserAuthenticateAdapter: UserAuthenticateAdapter = (
  data: ILoginResponseData
) => {
  const user: IUserLoggedEntity = {
    maxCoreTokenV1: data.maxCoreTokenV1,
    token: data.token,
    userData: {
      user_id: data.userData?.user_id as number,
      people_id: data.userData?.people_id as number,
      name: data.userData?.name as string,
      phone: data.userData?.phone as string,
      mobile: data.userData?.mobile as string,
      email: data.userData?.email as string,
      user_type: data.userData?.user_type as TRolesId,
      agency_id: data.userData?.agency_id as number,
      international_id: data.userData?.international_id as string,
      picture: data.userData?.picture as string,
      agency: data.userData?.agency as IAgencyBaseEntity,
      user_type_code: CRolesID[data.userData?.user_type as any],
      has_alterestate_token: data.userData
        ?.has_alterestate_token as number,
      is_profile_finished: data.userData?.is_profile_finished ?? 0
    }
  };
  return user;
};

export default UserAuthenticateAdapter;
